import CardBody from "components/card/CardBody"
import CustomCard from "components/card/CustomCard"
import CustomCardHeader from "components/card/CustomCardHeader"
import CustomButton from "components/CustomButton"
import { SemiTransparentButton } from "components/CustomButton"
import { DangerButton } from "components/CustomButton"
import CustomIcon from "components/CustomIcon"
import CustomTableItemLoader from "components/CustomTableItemLoader"
import CustomTable from "components/table/CustomTable"
import { TableHeader } from "components/table/CustomTable"
import { TableCell } from "components/table/CustomTable"
import { TableRow } from "components/table/CustomTable"
import ImageWrapper from "components/table/ImageWrapper"
import useDidMount from "hooks/useDidMount"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import ConfirmModal from "components/ConfirmModal"
import Viewer from "react-viewer"
import { tryGetPredictionCategoryInfo, tryDeletePredictionCategory } from "redux/slices/predictionSlice";
import PredictionCategoryForm from "./components/PredictionCategoryForm"
import { isoFormatToLocalTimeString } from "helpers/dateTimeHelper"
import { isoToLocaleFormat } from "helpers/dateTimeHelper"
import { utcDateTimeToLocalString } from "helpers/dateTimeHelper"


const PredictionCategoriesList = () => {

  const { campaign_id } = useParams()
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState();
  const [imagePreview, setImagePreview] = useState({
    visible: false,
    image: {},
  })

  const [showConfirmModal, setShowConfirmModal] = useState()

  const {
    category: { data, loading, processing, error }
  } = useSelector((state) => state.prediction)

  useEffect(() => {
    dispatch(tryGetPredictionCategoryInfo(campaign_id))
  }, [campaign_id])


  useDidMount(() => {
    setShowModal()
    setShowConfirmModal()
  }, [data])

  const removePredictionCategories = () => {
    dispatch(
      tryDeletePredictionCategory(
        showConfirmModal.id
      ),
    )
  }

  return (
    <div className="h-auto px-3 -mt-24 md:px-8">
      <div className="container max-w-full mx-auto">
        <div className="px-4 mb-16 grid grid-cols-1">
          <CustomCard>
            <CustomCardHeader color="blue" contentPosition="none">
              <div className="flex items-center justify-between w-full">
                <h2 className="text-white text-2xl">Prediction Categories List</h2>
                <SemiTransparentButton onClick={() => setShowModal({ id: campaign_id })}>
                  + Add New
                </SemiTransparentButton>
              </div>
            </CustomCardHeader>
            <CardBody>
              <div className="flex justify-end">

              </div>
              <CustomTable>
                <thead>
                  <TableRow>
                    <TableHeader>Title</TableHeader>
                    <TableHeader className="w-36">App Image</TableHeader>
                    <TableHeader className="w-36">Web Image</TableHeader>
                    <TableHeader className="w-36">App Banner</TableHeader>
                    <TableHeader className="w-36">Web Banner</TableHeader>
                    <TableHeader className="w-36">Expires At</TableHeader>
                    <TableHeader className="w-36">Frequency</TableHeader>
                    <TableHeader className="w-36">Interval</TableHeader>
                    <TableHeader className="w-36">Banner Url</TableHeader>
                  </TableRow>
                </thead>
                {loading || error.length || !data.length ? (
                  <CustomTableItemLoader
                    loading={loading}
                    error={error}
                    isEmpty={!data.length}
                    count={10}
                    colSpan={9}
                    key="notification-scheduled"
                    retry={() => {
                    }}
                  />
                ) : (
                  <tbody>
                    {data?.map((award, index) => (
                      <PredictionCategoriesItem
                        key={`${award}-${index}`}
                        item={award}
                        setImage={setImagePreview}
                        onEdit={() => {
                          setShowModal(award)
                        }}
                        onDelete={() => {
                          setShowConfirmModal({ id: award.id })
                        }}
                      />
                    ))}
                  </tbody>
                )}
              </CustomTable>
            </CardBody>
          </CustomCard>
        </div>
      </div>
      <PredictionCategoryForm
        showModal={showModal}
        setShowModal={setShowModal}
        loading={processing}
      />
      <ConfirmModal
        children="This will remove category. Are you sure?"
        disabled={false}
        showModal={!!showConfirmModal}
        setShowModal={() => setShowConfirmModal()}
        onConfirm={removePredictionCategories}
        loading={processing}
      />
      <Viewer
        visible={imagePreview.visible}
        onClose={() => {
          setImagePreview({ visible: false, image: {} })
        }}
        images={[imagePreview?.image]}
      />

    </div>
  )
}

export default PredictionCategoriesList;


const PredictionCategoriesItem = ({
  item,
  onEdit,
  onDelete,
  setImage,
  ...props
}) => {
  const datetime = utcDateTimeToLocalString(item.expiry_date, true, false).split(",");
  return (
    <TableRow {...props}>
      <TableCell>
        <Link
          key={item?.id}
          to={{
            pathname: `/predictions/${item.id}/candidates`,
          }}
        >
          <div className="font-bold mb-1 truncate link hover:opacity-80">{item?.title}</div>
        </Link>
      </TableCell>
      <TableCell>
        <ImageWrapper imageUrl={item.app_image_url} onImageClicked={() => {
          setImage({
            visible: true,
            image: { src: item.app_image_url }
          })
        }} />
      </TableCell>
      <TableCell>
        <ImageWrapper imageUrl={item.web_image_url} onImageClicked={() => {
          setImage({
            visible: true,
            image: { src: item.web_image_url }
          })
        }} />
      </TableCell>
      <TableCell>
        <ImageWrapper imageUrl={item.app_banner_url} onImageClicked={() => {
          setImage({
            visible: true,
            image: { src: item.app_banner_url }
          })
        }} />
      </TableCell>
      <TableCell>
        <ImageWrapper imageUrl={item.web_banner_url} onImageClicked={() => {
          setImage({
            visible: true,
            image: { src: item.web_banner_url }
          })
        }} />
      </TableCell>



      <TableCell>
        <div className="flex flex-col space-y-2">
          <div className="flex items-center space-x-1 text-sm leading-none">
            <CustomIcon icon="watch_later" size="sm" />{' '}

            <span>
              {datetime[0]}
            </span>
          </div>
          <div className="flex items-center space-x-1 text-sm leading-none">
            <CustomIcon icon="calendar_today" size="sm" />
            <span>
              {datetime[1]}
            </span>
          </div>
        </div>
      </TableCell>
      <TableCell>
        {item?.rule_set?.frequency}
      </TableCell>
      <TableCell>
        {item?.rule_set?.interval}
      </TableCell>
      <TableCell>
        <a href={item?.meta?.action_url} className="link" target="_blank">
          {item?.meta?.action_url}
        </a>
      </TableCell>
      <TableCell>
        <div className="flex space-x-2 justify-end">
          <CustomButton
            onClick={onEdit}
            isIconButton={true}
          >
            <CustomIcon icon="edit" />
          </CustomButton>
          <DangerButton
            onClick={onDelete}
            isIconButton={true}
          >
            <CustomIcon icon="delete" />
          </DangerButton>
        </div>
      </TableCell>
    </TableRow>
  )
}

export { PredictionCategoriesItem }
